import { render, staticRenderFns } from "./DataTableFilter.vue?vue&type=template&id=08fef770"
import script from "./DataTableFilter.vue?vue&type=script&lang=js"
export * from "./DataTableFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports